// extracted by mini-css-extract-plugin
module.exports = {"button":"src-screens-BrandsPage-components-List-TableTools-module__button--3qSuZ","wrapIcon":"src-screens-BrandsPage-components-List-TableTools-module__wrapIcon--2Zh-j"};